import { render } from "./ProductShowView.vue?vue&type=template&id=222bef70&scoped=true"
import script from "./ProductShowView.vue?vue&type=script&lang=js"
export * from "./ProductShowView.vue?vue&type=script&lang=js"

import "./ProductShowView.vue?vue&type=style&index=0&id=222bef70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222bef70"]])

export default __exports__